// src/theme.js
import { createTheme, alpha } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#3558a4',
            contrastText: '#fff',
        },
        secondary: {
            main: '#1ecab8',
            contrastText: '#fff',
        },
        background: {
            default: '#f3f6fb',
            paper: '#fff',
            sidebar: '#313a46',
        },
        text: {
            primary: '#313a46',
            secondary: '#6c757d',
        },
        divider: '#e9ecef',
        error: { main: '#f1646c' },
        warning: { main: '#ffa91f' },
        info: { main: '#50b5ff' },
        success: { main: '#1ecab8' },
    },
    shape: {
        borderRadius: 8,  // Slight rounding by default
    },
    typography: {
        fontFamily: "'Nunito', sans-serif",
        h1: { fontSize: '2.3rem', fontWeight: 700, color: '#313a46' },
        h2: { fontSize: '2rem', fontWeight: 600, color: '#313a46' },
        h3: { fontSize: '1.5rem', fontWeight: 600, color: '#313a46' },
        h4: { fontSize: '1.25rem', fontWeight: 600, color: '#313a46' },
        h5: { fontSize: '1.1rem', fontWeight: 600, color: '#313a46' },
        h6: { fontSize: '1rem', fontWeight: 500, color: '#313a46' },
        body1: { fontSize: '1rem', color: '#313a46' },
        body2: { fontSize: '0.95rem', color: '#6c757d' },
        button: {
            textTransform: 'none',
            fontWeight: 700,
            fontSize: '1rem',
            letterSpacing: '0.03em',
        },
    },
    components: {
        MuiButton: {
            defaultProps: {
                disableElevation: true,
                variant: 'soft',  // make "soft" the default variant
            },
            styleOverrides: {
                root: {
                    padding: '6px 16px',
                    fontWeight: 600,
                    borderRadius: theme => theme.shape.borderRadius,
                },
            },
            variants: [
                // Primary Soft
                {
                    props: { variant: 'soft', color: 'primary' },
                    style: {
                        backgroundColor: alpha('#3558a4', 0.1),
                        color: '#3558a4',
                        '&:hover': {
                            backgroundColor: alpha('#3558a4', 0.2),
                        },
                    },
                },
                // Secondary Soft
                {
                    props: { variant: 'soft', color: 'secondary' },
                    style: {
                        backgroundColor: alpha('#1ecab8', 0.1),
                        color: '#1ecab8',
                        '&:hover': {
                            backgroundColor: alpha('#1ecab8', 0.2),
                        },
                    },
                },
                // you can add more "soft" variants for info, warning, error, success...
            ],
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    background: '#313a46',
                    color: '#fff',
                    borderRight: 'none',
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    background: '#3558a4',
                    color: '#fff',
                    boxShadow: '0 2px 12px rgba(49, 58, 70, 0.07)',
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                    boxShadow: '0 1px 6px 0 rgba(49, 58, 70, 0.08)',
                },
            },
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    color: '#b6c2cd',
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                    fontWeight: 600,
                },
                colorPrimary: {
                    backgroundColor: '#3558a4',
                    color: '#fff',
                },
                colorSecondary: {
                    backgroundColor: '#1ecab8',
                    color: '#fff',
                },
            },
        },
        MuiAvatar: {
            styleOverrides: {
                root: {
                    backgroundColor: '#e9ecef',
                    color: '#313a46',
                    fontWeight: 700,
                },
            },
        },
    },
});

export default theme;
